export const LISTENER_KEYS = {
  XERO_CALLBACK: "XERO_CALLBACK",
  ON_GET_ELEMENT_RECT: "onGetElementRect",
};
